// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"124":"cb72996c","360":"3c54ef78"}[chunkId] + ".js";
};